// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"UserMenuItem-module_menuItem_17ox1"};